import { render, staticRenderFns } from "./CodeEdit.vue?vue&type=template&id=cc3c6532&scoped=true&"
import script from "./CodeEdit.vue?vue&type=script&lang=ts&"
export * from "./CodeEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CodeEdit.vue?vue&type=style&index=0&id=cc3c6532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3c6532",
  null
  
)

export default component.exports